import { render, staticRenderFns } from "./ProcessDetails.vue?vue&type=template&id=5cb868f8"
import script from "./ProcessDetails.vue?vue&type=script&lang=js"
export * from "./ProcessDetails.vue?vue&type=script&lang=js"
import style0 from "./ProcessDetails.vue?vue&type=style&index=0&id=5cb868f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports